module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"embeddings":"Embeddings","jwt":"JWT token","name":"Image file name"}}')
  delete Component.options._Ctor
}
